// WATER SOURCE TYPE
export const GET_WATER_SOURCE_TYPES = '/water_source_type/query';
export const GET_WATER_SOURCE_TYPE = '/water_source_type/';
export const POST_WATER_SOURCE_TYPE = '/water_source_type/';
export const PUT_WATER_SOURCE_TYPE = '/water_source_type/';
export const DELETE_WATER_SOURCE_TYPE = '/water_source_type/';
export const CHECK_WATER_SOURCE_TYPE_EXISTS = '/water_source_type/query';
